import React, { PureComponent } from 'react';

class TablaHeader extends PureComponent {
    constructor(props) {
        super(props);
        this.onClickdestildarTildarCheckAll = this.onClickdestildarTildarCheckAll.bind(this);
        this.state = {
            value: props.value || ""
        };
    }

    onClickdestildarTildarCheckAll(tipoCheck, estadoCheck, ajusteCargo) {
        this.props.destildarTildarCheckAll(tipoCheck, estadoCheck, ajusteCargo);
    }

    render() {
        const { ajusteCargoEstado, checkConfirmarAll, checkDenegarRestablecerAll, ajusteCargo } = this.props;

        let tituloCheckBox = undefined;

        //VER QUE ESTADOS MANEJA PARA ESTO
        switch (ajusteCargoEstado) {
            case "PEND. CONFIRMACIÓN":
                tituloCheckBox = "DENEGAR";
                break;
            case "DENEGADO":
                tituloCheckBox = "RESTABLECER ESTADO";
                break;
        }

        return <thead>
            <tr className="noBorder confirmadorAjusteCargoTableHeaderMain confirmadorAjusteCargoTable">
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderConfirmar'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>
                        <div>
                            CONFIRMAR
                            <div className={"default-checkbox checkProcesosSmall"}>
                                <input type="checkbox" onClick={() => this.onClickdestildarTildarCheckAll("C", checkConfirmarAll, ajusteCargo)} checked={checkConfirmarAll} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderDenegarRestablecer'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>
                        <div>
                            {tituloCheckBox}
                            <div className={"default-checkbox checkProcesosSmall"}>
                                <input type="checkbox" onClick={() => this.onClickdestildarTildarCheckAll("DR", checkDenegarRestablecerAll, ajusteCargo)} checked={checkDenegarRestablecerAll} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderDocumento'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>DOCUMENTO</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderNumeroCuenta'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>N° CUENTA</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderDebitoCredito'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>C/D</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderCodigo'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>COD</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderMotivo'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>MOTIVO</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderImporteSinIva'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>IMPORTE S/ IVA</div>
                </div>
                <div className='confirmadorAjusteCargoTableHeader confirmadorAjusteCargoTableHeaderFechaIngreso'>
                    <div className={"confirmadorAjusteCargoTableHeaderInsideDiv"}>FECHA INGRESO</div>
                </div>
                <div className={'confirmadorAjusteCargoTableHeader'}>
                    {/* Espacio para botón desplegable */}
                </div>
            </tr>
        </thead>
    }
}

export default TablaHeader;